export const STRING_JANUARY = 'January';
export const STRING_FEBRUARY = 'February';
export const STRING_MARCH = 'March';
export const STRING_APRIL = 'April';
export const STRING_MAY = 'May';
export const STRING_JUNE = 'June';
export const STRING_JULY = 'July';
export const STRING_AUGUST = 'August';
export const STRING_SEPTEMBER = 'September';
export const STRING_OCTOBER = 'October';
export const STRING_NOVEMBER = 'November';
export const STRING_DECEMBER = 'December';

export const STRING_FIELD_ATTACH_RESUME = 'Attach a resume file';
export const STRING_FIELD_RESUME_RESTRICT = 'PDF, DOC, TXT smaller than 10MB';
export const STRING_FIELD_REPLACE = 'Replace';
export const STRING_FIELD_REMOVE = 'Remove';
export const STRING_FIELD_NO_RESUME = 'I don’t have a resume file';

// input labels/placeholders
export const STRING_FIELD_EDUCATION_SCHOOL = 'School';
export const STRING_FIELD_EDUCATION_DEGREE = 'Degree';
export const STRING_FIELD_EDUCATION_MAJOR = 'Major or field of study (optional)';
export const STRING_FIELD_EDUCATION_CURRENT = 'Currently in progress';
export const STRING_FIELD_EDUCATION_DEGREE_YEAR = 'Degree Year';

export const STRING_FIELD_EXPERIENCE_TITLE = 'Job Title';
export const STRING_FIELD_EXPERIENCE_COMPANY = 'Company Name';
export const STRING_FIELD_EXPERIENCE_CURRENT = 'I currently work here';
export const STRING_FIELD_EXPERIENCE_START_MONTH = 'Start Month';
export const STRING_FIELD_EXPERIENCE_END_MONTH = 'End Month';

// common fields to multiple sections
export const STRING_FIELD_START_YEAR = 'Start Year';
export const STRING_FIELD_END_YEAR = 'End Year';
export const STRING_FIELD_DESCRIPTION = 'Description';
export const STRING_FIELD_DESCRIPTION_OPTIONAL = 'Description (Optional)';

export const STRING_FIELD_EMAIL_ADDRESS = 'Email Address';
export const STRING_FIELD_FULL_NAME = 'Full Name';
export const STRING_FIELD_PHONE_NUMBER = 'Phone Number';

// validations
export const STRING_FIELD_EMAIL_ADDRESS_REQUIRED = 'Please add an email address';
export const STRING_FIELD_EMAIL_ADDRESS_INVALID = 'Email Address is invalid';
export const STRING_FIELD_FULL_NAME_REQUIRED = 'Please add First and Last Name';
export const STRING_FIELD_PHONE_NUMBER_REQUIRED = 'Please add a phone number';
export const STRING_FIELD_RESUME_REQUIRED = 'Please add a resume';

// common fields to multiple sections
export const STRING_FIELD_START_YEAR_REQUIRED = 'Add a Start Year';
export const STRING_FIELD_END_YEAR_REQUIRED = 'Add an End Year';
export const STRING_FIELD_END_BEFORE_START_DATE = 'End is before Start'; // needs to be short to fit in small selects on mobile

export const STRING_FIELD_EXPERIENCE_TITLE_REQUIRED = 'Please add a Title';
export const STRING_FIELD_EXPERIENCE_COMPANY_REQUIRED = 'Please add a Company';
export const STRING_FIELD_EXPERIENCE_START_MONTH_REQUIRED = 'Add a Start Month';
export const STRING_FIELD_EXPERIENCE_START_DATE_REQUIRED = 'Add a Start Date';
export const STRING_FIELD_EXPERIENCE_END_MONTH_REQUIRED = 'Add an End Month';
export const STRING_FIELD_EXPERIENCE_END_DATE_REQUIRED = 'Add an End Date';

export const STRING_FIELD_EDUCATION_SCHOOL_REQUIRED = 'Please add a School';
export const STRING_FIELD_EDUCATION_DEGREE_REQUIRED = 'Please select a Degree';
